{
  "es": {
    "datatable": {
      "actions": {
        "bulk_action": "Acción masiva",
        "bulk_edit": "Editar en bloque",
        "clear": "Limpiar",
        "clear_filters": "Limpiar filtros",
        "collapse_all": "Contraer todo",
        "deselect_all": "Deseleccionar todo",
        "expand_all": "Expandir todo",
        "select_all": "Seleccionar todo"
      },
      "import": {
        "error_row": "Fila {row}",
        "errors_description": "La importación se canceló porque {count} fila(s) contenían errores. No se importó ningún registro.",
        "errors_title": "Error al importar",
        "success": "Archivo importado correctamente",
        "title": "Importar"
      },
      "labels": {
        "columns_selected": "{count} columnas seleccionadas",
        "freeze_columns": "Inmovilizar columnas",
        "freeze_rows": "Inmovilizar filas",
        "gridlines": "Líneas de cuadrícula",
        "group_by": "Agrupar por",
        "size": "Tamaño",
        "sticky_headers": "Encabezados fijos",
        "striped_rows": "Filas alternas",
        "toggle_columns": "Mostrar/ocultar columnas",
        "translation_mode_header": "Encabezado",
        "translation_mode_stacked": "Apilado",
        "translation_mode_toolbar": "Global",
        "translation_style": "Estilo de traducción"
      }
    }
  }
}
